import React from "react";

interface InputProps {
    label: string
    type: string
    name: string
    err?: boolean
    length?: number
    value?: string
    onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const InputField: React.FC<InputProps> = ({
    label,
    type,
    name,
    err,
    length,
    value,
    onChangeHandler
}) => {
    return (
        <div>
            <input 
                type={type}
                className="bg-gray-light text-lg px-3 py-2 rounded-lg w-full border-2 border-dark-green"
                placeholder={label}
                name={name}
                value={value}
                maxLength={length}
                onChange={onChangeHandler}
            />
        </div>
    )
}

export default InputField